import React, { useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import mainStyle from "../../style/Main.module.css";
import SearchComponent from "../../components/ui/input/Search/Search";
import Button from "../../components/ui/buttons/Button";
import companyStyle from "../../style/Pages/CompanyListPage.module.css";
import { FiEdit } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../components/ui/Loader/PageLoader";
import NoDataFound from "../../components/ui/NoDataFound/NoDataFound";
import EditCompanyPage from "./EditCompanyPage";
import PaginationComponent from "../../components/ui/Pagination/PaginationComponent";
import { useCompanyList } from "../../hooks/useCompany";

const CompanyListPage = () => {
  const perPage = 10;

  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [openEditCompany, isOpenEditCompany] = useState(false);
  const {
    companyList,
    companyCount,
    loading: isLoading,
    refresh: refreshCompanyList, // Make sure your useEmployeeList hook provides this
  } = useCompanyList(search);
  const openAddCompany = () => {
    navigate("/companylist/add");
  };

  const handleSearch = (term) => {
    if (term !== search) {
      setSearch(term);
      setCurrentPage(1);
    }
  };

  const openEdit = (data) => {
    setData(data);
    isOpenEditCompany(true);
  };

  const currentPageNo = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };
  const closeEdit = () => {
    refreshCompanyList();
    isOpenEditCompany(false);
  };
  return (
    <>
      <MainLayout>
        <div className={mainStyle.mainPageHeader}>
          <div>
            <p>Company List</p>
          </div>
          <div className={mainStyle.mainPageButtons}>
            <SearchComponent onSearch={handleSearch} />
            <Button onClick={openAddCompany}>Add Company</Button>
          </div>
        </div>

        <div className={mainStyle.mainContentView} style={{ height: "92%" }}>
          {isLoading ? (
            <PageLoader />
          ) : (
            <div className={mainStyle.mainContentViewsb}>
              {companyList && companyList.length > 0 ? (
                <div className={companyStyle.companyViewCard}>
                  {companyList?.map((company) => (
                    <div
                      key={company.id}
                      className={companyStyle.companyCardDiv}
                    >
                      <div
                        className={companyStyle.editIconWrapper}
                        onClick={() => openEdit(company)}
                      >
                        <FiEdit
                          className={companyStyle.companyeditIcon}
                          title="Edit Company"
                        />
                      </div>
                      <div className={companyStyle.companyCardLogoWrapper}>
                        <img
                          src={
                            `${apiUrl}${company.company_logo}` ||
                            "/default-logo.png"
                          }
                          alt={`${company.company_name} Logo`}
                          className={companyStyle.companyCardLogo}
                        />
                      </div>

                      <h3 className={companyStyle.companyNameView}>
                        {company.company_name}
                      </h3>
                      <p className={companyStyle.companyEmailView}>
                        {company.company_email}
                      </p>
                      <p className={companyStyle.companyEmpCoutView}>
                        {company.get_staff_count}
                      </p>
                    </div>
                  ))}
                </div>
              ) : (
                <NoDataFound
                  title="No Company Found"
                  description="No Company found. Click the button below to add a new."
                  buttonText="Add Company"
                  onButtonClick={openAddCompany}
                />
              )}
              <div>
                {!isLoading && companyCount > perPage && (
                  <PaginationComponent
                    pageCount={Math.ceil(companyCount / perPage)}
                    onPageChange={currentPageNo}
                    forcePage={currentPage - 1}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </MainLayout>
      {openEditCompany && (
        <EditCompanyPage
          show={openEditCompany}
          onClose={closeEdit}
          datas={data}
        />
      )}
    </>
  );
};

export default CompanyListPage;
